type TShirtSizes = 'nano' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
export type BreakpointName = TShirtSizes | 'default'

export type Breakpoint = {
  name: BreakpointName
  width: number
}

const breakpoints = [
  {
    name: 'default',
    width: 0,
  } as const,
  {
    name: 'nano',
    width: 250,
  } as const,
  {
    name: 'xxs',
    width: 320,
  } as const,
  {
    name: 'xs',
    width: 380,
  } as const,
  {
    name: 'sm',
    width: 470,
  } as const,
  {
    name: 'md',
    width: 600,
  } as const,
  {
    name: 'lg',
    width: 750,
  } as const,
  {
    name: 'xl',
    width: 950,
  } as const,
  {
    name: 'xxl',
    width: 1200,
  } as const,
] satisfies Breakpoint[]

export default breakpoints
